import React, { memo } from 'react'

const PageTitle = ({ text = '', className = '' }) => {
  return <h1 className={`page_title ${className}`}>{text}</h1>
}

export default memo(PageTitle)
